interface ITransactionAnomalyFeedbackIconProps {
  className?: string;
}

/**
 * Bar chart with one anomalous bar and an alert mark — the operator
 * metaphor is "spot the outlier transaction". Monoline, `currentColor`,
 * no fills. Designed on a 48×48 grid; the geometry survives scale-down to
 * the tile's ~48px and up to the page.
 */
const TransactionAnomalyFeedbackIcon = ({ className }: ITransactionAnomalyFeedbackIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* axes */}
    <path d="M8 8 v32 h32" strokeLinecap="square" />
    {/* normal bars (short) */}
    <rect x="13" y="32" width="4" height="8" />
    <rect x="20" y="28" width="4" height="12" />
    <rect x="34" y="30" width="4" height="10" />
    {/* anomalous tall bar with extended top */}
    <rect x="27" y="14" width="4" height="26" />
    {/* alert mark above the anomalous bar */}
    <circle cx="29" cy="9" r="2" />
  </svg>
);

export default TransactionAnomalyFeedbackIcon;
